export class SortBackupJobBy {
    'field';
    'order';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "BackupJobSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortBackupJobBy.attributeTypeMap;
    }
    constructor() {
    }
}
